var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",staticStyle:{"width":"50%"}},[_c('div',{staticClass:"text-left px-5 mt-0 h-100 h2 section-title"},[_c('div',{staticClass:"col-md-12 px-5"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }